import React, { ComponentType, ReactNode } from 'react'
import { useToolbar } from '@workwave-tidal/lab/Toolbar'
import Box, { BoxProps } from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

type Props = {
  logo: ReactNode
  activeLogo: ReactNode
}

export function CustomToolbarLogo(props: Props) {
  const { logo = <div />, activeLogo = <div /> } = props
  const { views } = useToolbar()
  const tidalThemeActive = useTidalThemeActive()

  // track if there is an active view
  const active = views.length > 0

  return (
    <Box
      mb={4}
      px={tidalThemeActive ? 2 : 1}
      py={tidalThemeActive ? 1.5 : 0.6}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LogoContainer>{active ? activeLogo : logo}</LogoContainer>
    </Box>
  )
}

const LogoContainer = styled(Box)<BoxProps>(() => ({
  '& > *': { maxWidth: '100%', width: '100%' },
  height: 40,
  maxWidth: 40,
})) as ComponentType<BoxProps>
